import React from 'react';

import Events from './Events';

function EventsWrapper() {
	return (
		<div className="body-content bg-fff pt-80l-70m-60s pb-120">

			<div className="panel large pt-20l-10s">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-left">
						<div className="font-libre-baskerville font-size-24l-20m-16s font-weight-800 bb1-555 pb-5">Events</div>
					</div>
				</div>
			</div>

			<div className="">
				<Events />
			</div>

		</div>
	);
}

export default EventsWrapper;